import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scada_nav_component = _resolveComponent("scada-nav-component")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_scada_nav_component, {
          key: 0,
          isPV: true
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}